export default __webpack_public_path__ + "static/media/timepopUp.28d9a85f.svg";